import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Menu',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#F5F1ED]/90 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-99">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-100">
        <a href="#" className="flex items-center" data-id="element-101">
          <img src="https://cdn.magicpatterns.com/uploads/i1ZLuXurjBTH6AfeJrztMH/Large_Logo_(Transparent).png" alt="Grounded Mornings" className="h-40 w-auto" data-id="element-102" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-2" data-id="element-103">
          {navLinks.map(link => <a key={link.name} href={link.href} className="px-6 py-2 rounded-full text-sm font-medium text-[#2D3748] hover:bg-[#E8E3DD] transition-colors duration-200" data-id="element-104">
              {link.name}
            </a>)}
          <a href="#contact" className="ml-4 px-6 py-2 rounded-full text-sm font-medium bg-[#2D3748] text-[#F5F1ED] hover:bg-[#1a202c] transition-colors duration-200" data-id="element-105">
            Book Now
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-[#2D3748]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-106">
          {isMobileMenuOpen ? <X size={24} data-id="element-107" /> : <Menu size={24} data-id="element-108" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-109">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-[#F5F1ED] border-t border-[#E8E3DD]" data-id="element-110">
            <div className="flex flex-col p-6 space-y-4" data-id="element-111">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-[#2D3748]" data-id="element-112">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="inline-block text-center px-6 py-3 rounded-full text-sm font-medium bg-[#2D3748] text-[#F5F1ED]" data-id="element-113">
                Book Now
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}